import axios from 'axios';
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';


export interface IPostSubscribePayload {
    szf_email: string
}
export interface IPostSubscribe {
    email: string,
    CRMtoken: string | undefined;
}


/**
 * PostSubscribe Input Action
 */
export class PostSubscribeInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public szf_email: string;
    public CRMtoken: string | undefined;
    constructor(data: IPostSubscribe) {
        this.szf_email= data.email;
        this.CRMtoken= data.CRMtoken;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SZFSUBSCRIBE`;
    public getCacheObjectType = () => 'SZFSUBSCRIBE';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPostSubscribeData {
    IsSuccess?: boolean;
    Message?: string;
    Data?: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInputSubscribeInput = (args: Msdyn365.ICreateActionContext, inputData: IPostSubscribe): Msdyn365.IActionInput => {
    return new PostSubscribeInput(inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function SubscribeDataAction(input: PostSubscribeInput, ctx: Msdyn365.IActionContext): Promise<IPostSubscribeData> {
    try {
        const data: IPostSubscribePayload = {
            "szf_email": input.szf_email,
        };
        const szfCRMDomain = ctx.requestContext.app.config.szfCRMDomain;
        const subscribeResponse = await axios.post(`${szfCRMDomain}/api/data/v9.2//szf_newsletters`,data,{
            headers: { 
                'Prefer': 'return=representation', 
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${input.CRMtoken}`,
                'Cookie': 'ARRAffinity=a0cabaca1e89d18f0f4123d056dbb9e1cefb17d8da01b66962b2dc7ffb4a189deb29bb4b19df1459d2ea781b605f33064b9fea1f144b525b9d7676625c4ffb5408DB5EAB3C80FFDC613303632; ReqClientId=797635cc-3220-4d23-95ab-4c1fd0f38f88; orgId=df0699dc-bf43-4643-8928-2934590e2913'
            },
            timeout: 25000
        })
        if(subscribeResponse.data){
            return {
                IsSuccess: true,
                Message: "Subscribe API Successfully Call.",
                Data: subscribeResponse.data
            }
        }else{
            return { 
                IsSuccess: false,
                Message: "Something went wrong.",
            }
        }
    } catch (error) {
        console.log("🚀 ~ error:", error)
        return { 
            IsSuccess: false,
            Message: "Something went wrong.",
        }
    }
    
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPostSubscribeData[]>('/get/example/id/1', 'get');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostSubscribeData>>SubscribeDataAction,
    // TODO: Give your data action a unique id
    id: 'PostSubscribe',
    input: createInputSubscribeInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
